import React from 'react';

export const Extension = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    height='25'
    viewBox='0 0 24 21'
    className='app-icon'
  >
    <defs></defs>
    <g transform='translate(11024 -18800.5)'>
      <path
        className='cls-extension-defi-wallet-1'
        d='M21.619-15H3.75A.75.75,0,0,1,3-15.75a.75.75,0,0,1,.75-.75h18a.75.75,0,0,0,.75-.75,2.25,2.25,0,0,0-2.25-2.25H3a3,3,0,0,0-3,3v15a3,3,0,0,0,3,3H21.619A2.321,2.321,0,0,0,24-.75v-12A2.321,2.321,0,0,0,21.619-15Z'
        transform='translate(-11024 18820)'
        fill='#ffffff'
      ></path>
      <g transform='translate(-11017.25 18810) scale(0.3)'>
        <path d='M17.8956 12.0018L32.0458 4.52327L29.6668 0L16.7098 5.18441C16.3761 5.31809 16.0062 5.31809 15.6726 5.18441L2.71192 0L0.333008 4.52327L14.4832 12.0018L0.333008 19.4767L2.71192 24L15.669 18.8156C16.0027 18.6819 16.3725 18.6819 16.7061 18.8156L29.6632 24L32.0421 19.4767L17.8919 11.9982L17.8956 12.0018Z'></path>
      </g>
      <circle
        className='cls-extension-defi-wallet-2'
        cx='1.314'
        cy='1.314'
        r='1.314'
        transform='translate(-11004.771 18812.314)'
      ></circle>
    </g>
  </svg>
);
